<template>
  <div class="charge-detail">
    <div class="main-title">
      <p v-if="type==1" @click="toList">{{ $t('lang.Charging pile management') }}</p>
      <p v-if="type==1" @click="toDetail">>{{ $t('lang.Details') }}</p>
      <p v-if="type==1">>{{ $t('lang.Equipment snapshot') }}</p>
      <p v-if="type==2" @click="toList">
        {{ deviceType == 4 ? $t('lang.Charging charge station management') : $t('lang.Change charge station management') }}</p>
      <p v-if="type==2" @click="toDetail">>{{ $t('lang.Details') }}</p>
      <p v-if="type==2">>{{ $t('lang.Equipment snapshot') }}</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">{{ $t('lang.Equipment number') }}：</div>
        <div class="value-label">{{ primaryDeviceNo }}</div>
      </div>
      <div class="list">
        <span>{{ $t('lang.time') }}：</span>
        <el-date-picker
          v-model="beginTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.start time')">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.end time')">
        </el-date-picker>
        <span class="ml10">{{ $t('lang.Port number') }}：</span>
        <el-input class="list-input" size="mini" v-model="chargePortSeqNo"></el-input>
        <div class="blue-btn ml10" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</div>
      </div>
      <!-- <el-table
       class="mb20"
       :data="tableData"
       style="width: 100%">
       <el-table-column  prop="name" label="设备快照编号"></el-table-column>
       <el-table-column  prop="name" label="接收时间"></el-table-column>
       <el-table-column  prop="name" label="端口编号"></el-table-column>
       <el-table-column  prop="name" label="端口状态"></el-table-column>
       <el-table-column  prop="name" label="端口电流"></el-table-column>
       <el-table-column  prop="name" label="端口电压"></el-table-column>
       <el-table-column  prop="name" label="端口服务状态"></el-table-column>
       <el-table-column  prop="name" label="柜门状态"></el-table-column>
       <el-table-column  prop="name" label="电池通讯板号"></el-table-column>
       <el-table-column  prop="name" label="电池电量"></el-table-column>
       <el-table-column  prop="name" label="电池电流"></el-table-column>
       <el-table-column  prop="name" label="健康状态">
         <template slot-scope="{row}">
         </template>
       </el-table-column>
     </el-table>
     <div class="dfcc">
       <el-pagination
         background
         prev-text="上一页"
         next-text="下一页"
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page="currentPage4"
         :page-sizes="[100, 200, 300, 400]"
         :page-size="100"
         layout="total, sizes, prev, next, jumper"
         :total="total">
       </el-pagination>
     </div> -->
      <table class="table-custom">
        <thead>
        <tr>
          <th style="width:200px">{{ $t('lang.Equipment snapshot number') }}</th>
          <th>{{ $t('lang.Receiving time') }}</th>
          <th>{{ $t('lang.Port number') }}</th>
          <th>{{ $t('lang.Port state') }}</th>
          <th>{{ $t('lang.Port current') }}</th>
          <th>{{ $t('lang.Port voltage') }}</th>
          <th style="width:130px" v-if="type==2">{{ $t('lang.Port service status') }}</th>
          <th style="width:150px" v-if="type==2">{{ $t('lang.State of cabinet door') }}</th>
          <th v-if="type==2">{{ $t('lang.battery SN') }}</th>
          <th v-if="type==2">{{ $t('lang.Battery Power') }}</th>
          <th v-if="type==2">{{ $t('lang.Battery current') }}</th>
          <th v-if="type==2">{{ $t('lang.Health level') }}</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ $changeTime.showTime(item.createTime) }}</td>
          <td>{{ item.chargePortSeqNo ? item.chargePortSeqNo + $t('lang.No') : "--" }}</td>
          <td>{{ $t('lang.' + $changeObj(status_Code_port)[item.statusCode]) }}</td>
          <td>{{ item.electricCurrent }}</td>
          <td>{{ item.electricVoltage }}</td>
          <td v-if="type==2">{{ portServiceStatusMap[item.serviceStatus]}}</td>
          <td v-if="type==2">{{ $t('lang.' + $changeObj(door_Status_Code)[item.doorStatusCode]) }}</td>
          <td v-if="type==2">{{ item.batteryCommunicationBoardNo }}</td>
          <td v-if="type==2">{{ item.batterySoc }}</td>
          <td v-if="type==2">{{ item.batteryElectricCurrent }}</td>
          <td v-if="type==2">{{ item.batterySoh }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td :colspan="type==1?'6':'13'">{{ $t('lang.no data') }}</td>
        </tr>
        </tbody>
      </table>

      <div class="page-box">
        <div class="page-count">{{ $t('lang.The') }} {{ pageIndex }} {{ $t('lang.page') }}
          ，{{ $t('lang.The current page') }} {{ dataList.length }} {{ $t('lang.item') }}，{{ total }}
          {{ $t('lang.item') }}
        </div>
        <div class="page-count"> {{ $t('lang.Jump to') }}
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          {{ $t('lang.page') }}
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">{{ $t('lang.Jump to') }}</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">
          {{ $t('lang.Previous page') }}
        </div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">
          {{ $t('lang.Next page') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";
import {status_Code_port, door_Status_Code} from '@/utils/constant'

export default {
  name: 'snapShot',
  data() {
    return {
      door_Status_Code,
      status_Code_port,
      total: 0,
      tableData: [],
      title: '',
      type: '',
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      beginTime: '',
      endTime: '',
      chargePortSeqNo: '',
      primaryDeviceNo: '',
      portServiceStatusMap: {
        '-1': this.$t('lang.Not shown'),
        '1': this.$t('lang.Enable'),
        '0': this.$t('lang.unenable'),
      },
      dataList: [],
      loading: false,
      searchCondition: '',
      deviceName: '',
      begin: 0,
      deviceType:''
    }
  },
  mounted() {
    this.beginTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    if (this.$route.query.primaryDeviceNo) {
      this.primaryDeviceNo = this.$route.query.primaryDeviceNo;
      this.querySnapshot();
    }
    if (this.$route.query.type) {
      if (this.$route.query.type == '1') {
        this.type = 1;
      }
      if (this.$route.query.type == '2') {
        this.type = 2;
      }
    }
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.deviceName) {
      this.deviceName = this.$route.query.deviceName;
    }
    if (this.$route.query.beginIndex) {
      this.begin = this.$route.query.beginIndex;
    }
    if (this.$route.query.deviceType) {
      this.deviceType = this.$route.query.deviceType;
    }
  },
  methods: {
    handleCurrentChange(i) {

    },
    handleSizeChange(pagesize) {

    },


    querySnapshot() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo,
        chargePortSeqNo: this.chargePortSeqNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.$changeTime.sendTime(this.beginTime, 'YYYY-MM-DD HH:mm'),
        endTime: this.$changeTime.sendTime(this.endTime, 'YYYY-MM-DD HH:mm')
      };
      this.$http.post('/managementPlatform/electricity/querySnapshot', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySnapshot();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySnapshot();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySnapshot();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.querySnapshot();
    },
    queryCellVoltage(batteryNo, beginTime) {
      let self = this;
      let params = {
        batteryNo: batteryNo,
        beginTime: beginTime
      };
      this.$http.post('/managementPlatform/electricity/queryBatteryCellSnapshot', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        res.ldata.forEach(v => {
          v.cellSeqNo += self.$t('lang.No')
          v.electricVoltage += 'V'
        })
        self.tableData = res.ldata;
        self.loading = false;
      }).catch(function (response) {
        console.log(response);
      });
    },
    toList() {
      if (this.type == 1) {
        this.$router.push("/managePage/chargeMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      } else {
        if (this.deviceType == 4) {
          this.$router.push("/managePage/chargeCabinetMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
        } else {
          this.$router.push("/managePage/batterySwapMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
        }
      }
    },
    toDetail() {
      if (this.type == 1) {
        this.$router.push("/managePage/chargeMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      } else {
        if (this.deviceType == 4) {
          this.$router.push("/managePage/chargeCabinetMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
        } else {
          this.$router.push("/managePage/batterySwapMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  width: 100%;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.pre-btn {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/snapShot.vue